<template>
  <div class="bg-[#F2F6FA] h-full">
    <div class="flex flex-col items-center justify-center w-full pb-20">
      <section class="flex flex-col items-center w-full justify-center">
        <div
          class="flex items-center justify-between md:mt-5 mb-2 md:mb-0 mt-2 px-2 md:px-0 w-full"
        >
          <div class="items-center gap-2 px-4 mt-5 -ml-2 d-flex">
            <img
              src="@/assets/img/sidebar/pr_g.png"
              class="cursor-pointer w-6 md:w-[28px]"
              alt="post"
            />
            <div class="flex items-center gap-1">
              <p class="text-base md:text-[22px] font-bold">Profiles Manager</p>
            </div>
          </div>
        </div>
        <div class="min-h-screen w-full overflow-x-hidden rounded-2xl mt-5">
          <v-tabs v-model="activeTab">
            <v-tab value="dashboard">Profile Dashboard</v-tab>
            <v-tab value="profiles">All Profiles</v-tab>
            <v-tab value="bulk">Bulk Updates</v-tab>
            <v-tab value="history">Update History</v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab" class="rounded-b-2xl">
            <v-tab-item :value="0" class="mt-5">
              <GMBProfileDashboard
                :categories="categories"
                :locations="locations"
                :categoriesId="categoriesId"
                :fetch-workspace-data="fetchWorkspaceData"
              />
            </v-tab-item>
            <v-tab-item :value="1" class="mt-5">
              <GMBAllProfiles
                :categories="categories"
                :locations="locations"
                :categoriesId="categoriesId"
                :fetch-workspace-data="fetchWorkspaceData"
                @connect-gmb="handleConnectGMB"
                @clearSearchQuery="clearSearchQuery"
              />
            </v-tab-item>
            <!-- Bulk Updates Tab -->
            <v-tab-item :value="2">
              <GMBBulkUpdate
                :locations="locations"
                :categories="categories"
                :categoriesId="categoriesId"
                :fetch-workspace-data="fetchWorkspaceData"
              />
            </v-tab-item>

            <!-- Update History Tab -->
            <v-tab-item :value="3">
              <GMBProfileHistory :categories="categories" />
            </v-tab-item>
          </v-tabs-items>
          <div
            class="container mx-auto w-full px-4 md:px-8 lg:px-12 xl:px-16 max-w-[1285px]"
          >
            <!-- Header -->

            <!-- Add this button section below the header -->
            <!-- Note -->

            <!-- Add this note section after the existing note -->
            <!-- <div class="mb-6 px-4">
              <div v-if="!checkUpdateEligibility(gmb_bulk_last_updated).canUpdate"
                class="flex items-center text-gray-800 bg-yellow-50 p-4 rounded-md border-l-4 border-yellow-500 shadow-sm">
                <v-icon color="warning" class="mr-3">mdi-clock-alert</v-icon>
                <span class="font-medium">
                  Bulk updates will be available in {{ checkUpdateEligibility(gmb_bulk_last_updated).remainingTime }}
                  hours
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from "firebase/functions";
import { auth, functions, storage } from "@/utils/firebase.utils";
import GMBProfileHistory from "./gmb_profile_components/GMBProfileHistory.vue";
import GMBBulkUpdate from "./gmb_profile_components/GMBBulkUpdate.vue";
import GMBAllProfiles from "./gmb_profile_components/GMBAllProfiles.vue";
import GMBProfileDashboard from "./gmb_profile_components/GMBProfileDashboard.vue";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where,
  limit,
  startAfter,
} from "firebase/firestore";
import { db } from "@/utils/firebase.utils"; // Ensure you have a Firestore instance
import connectedAppsMixins from "@/mixins/connected.apps.mixins";

export default {
  components: {
    GMBProfileHistory,
    GMBBulkUpdate,
    GMBAllProfiles,
    GMBProfileDashboard,
  },
  mixins: [connectedAppsMixins],
  data() {
    return {
      loading: false,
      locations: [],
      categories: [],
      categoriesId: [],
      locationIds: [],
      activeTab: 0,
      weekDays: [
        { label: "Sunday", value: "SUNDAY" },
        { label: "Monday", value: "MONDAY" },
        { label: "Tuesday", value: "TUESDAY" },
        { label: "Wednesday", value: "WEDNESDAY" },
        { label: "Thursday", value: "THURSDAY" },
        { label: "Friday", value: "FRIDAY" },
        { label: "Saturday", value: "SATURDAY" },
      ],
      gmb_bulk_last_updated: null,
      selectedWIDs: [],
      tabs: {
        dashboard: 0,
        all_profiles: 1,
        bulk_updates: 2,
        update_history: 3,
      },
    };
  },

  async created() {
    console.log("Initial locations prop data:", this.locations);
    if (this.$route.query.tab) {
      this.activeTab = this.tabs[this.$route.query.tab];
    }
    await this.fetchLastUpdatedAndRefreshed();
    await this.fetchWorkspaceData();
    console.log("Locations after fetchWorkspaceData:", this.locations);
    await this.fetchGMBCategories();
  },

  methods: {
    clearSearchQuery() {
      let query = { ...this.$route.query };
      if (query.location) {
        delete query.location;
      }
      if (query.name) {
        delete query.name;
      }
      this.$router.replace({
        query: query,
      });
      this.fetchWorkspaceData();
    },
    formatTime(time) {
      if (!time) return "";
      if (Object.keys(time).length == 0) {
        time = { hours: 0, minutes: 0 };
      }
      return `${String(time.hours).padStart(2, "0")}:${String(
        time.minutes || 0
      ).padStart(2, "0")}`;
    },

    async handleConnectGMB() {
      try {
        this.$snackbar.show("Please wait a moment");
        this.isLoading = true;

        // Use the initConnection method from the connected.apps.mixins.js
        await this.initConnection("google_business_profile", "bulk");

        setTimeout(() => {
          this.$snackbar.hide();
        }, 2000);
      } catch (error) {
        console.error("Error connecting Google Business Profile:", error);
        this.$alert.show(
          "Failed to start Google Business connection. Please try again."
        );
      } finally {
        this.isLoading = false;
      }
    },

    async fetchWorkspaceData(workspaceID) {
      try {
        if (workspaceID) {
          // Handle specific workspace fetching (unchanged)
          console.log(workspaceID, "updating for a specific workspace");
          const workspaceDoc = doc(
            db,
            "users",
            this.currentUID,
            "fly_workspaces",
            workspaceID
          );
          try {
            const snapshot = await getDoc(workspaceDoc);
            if (snapshot.exists()) {
              const workspaceData = snapshot.data();
              const updatedLocation = snapshot.data()?.gmbProfile;
              if (!updatedLocation) {
                console.log(
                  `No gmbProfile found for workspace ID ${workspaceID}, skipping.`
                );
                return;
              }
              const index = this.locations.findIndex(
                (location) => location.workspaceId === workspaceID
              );
              if (index !== -1) {
                this.$set(this.locations, index, {
                  ...this.locations[index],
                  ...updatedLocation,
                  gmb_shallow_profile_data: workspaceData?.shallowConnect
                    ? workspaceData?.gmb_shallow_profile_data
                    : null,
                  nameEditable: false,
                  categoryEditable: false,
                  primaryCategorySearchQuery: "",
                  gmbLastFetchedAt: snapshot.data()?.gmbLastFetchedAt,
                  selectedPrimaryCategory: null,
                  formData: {
                    businessName: updatedLocation?.title || "",
                    primaryPhone: this.formatFetchedPhoneNumber(
                      updatedLocation?.phoneNumbers?.primaryPhone || ""
                    ),
                    primaryCategory:
                      updatedLocation?.categories?.primaryCategory || {},
                    websiteUri: updatedLocation?.websiteUri || "",
                    description: updatedLocation?.profile?.description || "",
                    additionalCategories: (
                      updatedLocation?.categories?.additionalCategories || []
                    ).map((cat) => ({
                      ...cat,
                      isOriginal: true,
                    })),
                    openInfo: {
                      status: updatedLocation?.openInfo?.status || "OPEN",
                      openingDate: updatedLocation?.openInfo?.openingDate || {
                        year: new Date().getFullYear(),
                        month: new Date().getMonth() + 1,
                        day: new Date().getDate(),
                      },
                    },
                    regularHours: this.weekDays.reduce((acc, day) => {
                      acc[day.value] = {
                        isOpen: false,
                        open: "09:00",
                        close: "17:00",
                        openMenu: false,
                        closeMenu: false,
                      };
                      if (updatedLocation?.regularHours?.periods) {
                        const matchingPeriod =
                          updatedLocation.regularHours.periods.find(
                            (period) =>
                              period.openDay === day.value &&
                              period.closeDay === day.value
                          );
                        if (matchingPeriod) {
                          acc[day.value].isOpen = true;
                          acc[day.value].open = this.formatTime(
                            matchingPeriod.openTime
                          );
                          acc[day.value].close = this.formatTime(
                            matchingPeriod.closeTime
                          );
                        }
                      }
                      return acc;
                    }, {}),
                    originalRegularHours: this.weekDays.reduce((acc, day) => {
                      acc[day.value] = {
                        isOpen: false,
                        open: "09:00",
                        close: "17:00",
                        openMenu: false,
                        closeMenu: false,
                      };
                      if (updatedLocation?.regularHours?.periods) {
                        const matchingPeriod =
                          updatedLocation.regularHours.periods.find(
                            (period) =>
                              period.openDay === day.value &&
                              period.closeDay === day.value
                          );
                        if (matchingPeriod) {
                          acc[day.value].isOpen = true;
                          acc[day.value].open = this.formatTime(
                            matchingPeriod.openTime
                          );
                          acc[day.value].close = this.formatTime(
                            matchingPeriod.closeTime
                          );
                        }
                      }
                      return acc;
                    }, {}),
                  },
                });
              }
            }
          } catch (error) {
            console.error(
              `Error fetching workspace document for ID ${workspaceID}:`,
              error
            );
          }
        } else {
          this.loading = true;
          this.selectedWIDs = [];
          this.locations = [];

          try {
            const batchSize = 500;
            let lastDoc = null;
            let hasMore = true;
            let locationIdsArray = [];

            while (hasMore) {
              if (this.$route.query.location) {
                const locationParam = this.$route.query.location;
                const locationIds = locationParam
                  ? Array.isArray(locationParam)
                    ? locationParam
                    : [locationParam]
                  : [];

                // Convert to array if it's a comma-separated string (e.g., "id1,id2,id3")
                locationIdsArray =
                  locationIds.length === 1 && locationIds[0].includes(",")
                    ? locationIds[0].split(",").map((id) => id.trim())
                    : locationIds;
              }
              // Define the base query
              let collectionRef = query(
                collection(db, "users", this.currentUID, "fly_workspaces"),
                where("storeWorkspace", "==", true),
                where("admin", "==", this.WID),
                limit(batchSize)
              );

              // Apply pagination if there's a last document
              if (lastDoc) {
                collectionRef = query(
                  collection(db, "users", this.currentUID, "fly_workspaces"),
                  where("storeWorkspace", "==", true),
                  where("admin", "==", this.WID),
                  startAfter(lastDoc),
                  limit(batchSize)
                );
              }

              // Fetch the batch
              const snapshot = await getDocs(collectionRef);
              const workspaceDocs = snapshot.docs;

              if (workspaceDocs.length === 0) {
                hasMore = false;
                break;
              }

              // Update lastDoc for the next batch
              lastDoc = workspaceDocs[workspaceDocs.length - 1];

              // Prepare promises for fetching GMB attributes in parallel
              const gmbFetchPromises = workspaceDocs.map(
                async (docSnapshot) => {
                  try {
                    const workspaceData = docSnapshot.data();
                    const location = workspaceData?.gmbProfile;

                    if (!location) {
                      console.log(
                        `No gmbProfile found for document ID ${docSnapshot.id}, skipping.`
                      );
                      return null;
                    }
                    // if locationsIdsArray is not empty, then match it with doc id and filter out the rest of the locations
                    if (locationIdsArray.length > 0) {
                      if (!locationIdsArray.includes(docSnapshot.id)) {
                        return null;
                      }
                    }

                    const profileData = {
                      ...location,
                      sub_locality: workspaceData?.sub_locality || null,
                      city: workspaceData?.city || null,
                      state: workspaceData?.state || null,
                      gmbLastFetchedAt: workspaceData?.gmbLastFetchedAt,
                      gmb_shallow_profile_data: workspaceData?.shallowConnect
                        ? workspaceData?.gmb_shallow_profile_data
                        : null,
                      workspaceId: docSnapshot.id,
                      wid: docSnapshot.id,
                      storeLocation: workspaceData?.storeLocation || "",
                      shallowConnect: workspaceData?.shallowConnect || false,
                      formData: {
                        businessName: location?.title || "",
                        primaryPhone: this.formatFetchedPhoneNumber(
                          location?.phoneNumbers?.primaryPhone || ""
                        ),
                        primaryCategory:
                          location?.categories?.primaryCategory || {},
                        websiteUri: location?.websiteUri || "",
                        description: location?.profile?.description || "",
                        additionalCategories: (
                          location?.categories?.additionalCategories || []
                        ).map((cat) => ({
                          ...cat,
                          isOriginal: true,
                        })),
                        openInfo: {
                          status: location?.openInfo?.status || "OPEN",
                          openingDate: location?.openInfo?.openingDate || {
                            year: new Date().getFullYear(),
                            month: new Date().getMonth() + 1,
                            day: new Date().getDate(),
                          },
                        },
                        regularHours: this.weekDays.reduce((acc, day) => {
                          acc[day.value] = {
                            isOpen: false,
                            open: "09:00",
                            close: "17:00",
                            openMenu: false,
                            closeMenu: false,
                          };
                          if (location?.regularHours?.periods) {
                            const matchingPeriod =
                              location.regularHours.periods.find(
                                (period) =>
                                  period.openDay === day.value &&
                                  period.closeDay === day.value
                              );
                            if (matchingPeriod) {
                              acc[day.value].isOpen = true;
                              acc[day.value].open = this.formatTime(
                                matchingPeriod.openTime
                              );
                              acc[day.value].close = this.formatTime(
                                matchingPeriod.closeTime
                              );
                            }
                          }
                          return acc;
                        }, {}),
                        originalRegularHours: this.weekDays.reduce(
                          (acc, day) => {
                            acc[day.value] = {
                              isOpen: false,
                              open: "09:00",
                              close: "17:00",
                              openMenu: false,
                              closeMenu: false,
                            };
                            if (location?.regularHours?.periods) {
                              const matchingPeriod =
                                location.regularHours.periods.find(
                                  (period) =>
                                    period.openDay === day.value &&
                                    period.closeDay === day.value
                                );
                              if (matchingPeriod) {
                                acc[day.value].isOpen = true;
                                acc[day.value].open = this.formatTime(
                                  matchingPeriod.openTime
                                );
                                acc[day.value].close = this.formatTime(
                                  matchingPeriod.closeTime
                                );
                              }
                            }
                            return acc;
                          },
                          {}
                        ),
                      },
                      gmb_last_updated: workspaceData?.gmb_last_updated || null,
                      keywords: workspaceData?.gmbKeywords || [],
                      currentKeyword: "",
                      showHours: false,
                      showOpenInfo: false,
                      checked: true,
                      updating: false,
                      nameEditable: false,
                      websiteUriEditable: false,
                      descriptionEditable: false,
                      categoryEditable: false,
                      generatingDescription: false,
                      applyingDescription: false,
                      needs_gmb_reauth:
                        workspaceData?.needs_gmb_reauth || false,
                      newDescription: null,
                      selectedAdditionalCategory: null,
                      selectedPrimaryCategory: null,
                      additionalCategorySearchQuery: "",
                      primaryCategorySearchQuery: "",
                      suggestingCategories: false,
                    };

                    // Extract location ID and fetch GMB attributes
                    let locationId = location.name.split("/")[1]; // e.g., "2464362357031066723"
                    if (profileData.shallowConnect) {
                      locationId = workspaceData.placeId;
                    }
                    const gmbAttributesDocRef = doc(
                      db,
                      "gmb_attributes",
                      locationId
                    );
                    const gmbAttributesSnapshot = await getDoc(
                      gmbAttributesDocRef
                    );

                    if (gmbAttributesSnapshot.exists()) {
                      return {
                        ...profileData,
                        gmb_attributes:
                          gmbAttributesSnapshot.data()?.attributes,
                      };
                    } else {
                      console.log(
                        `No GMB attributes found for location ${locationId}`
                      );
                      return {
                        ...profileData,
                        gmb_attributes: [],
                      };
                    }
                  } catch (error) {
                    console.error(
                      `Error processing document ${docSnapshot.id}:`,
                      error
                    );
                    return null;
                  }
                }
              );

              // Fetch GMB attributes in parallel for this batch
              const locationsWithAttributes = await Promise.all(
                gmbFetchPromises
              );

              // Filter out null values and append to this.locations
              const validLocations = locationsWithAttributes.filter(
                (location) => location !== null
              );
              this.locations = [...this.locations, ...validLocations];
              this.selectedWIDs.push(...validLocations.map((loc) => loc.wid));

              // Check if there are more documents to fetch
              hasMore = workspaceDocs.length === batchSize;
            }
          } catch (error) {
            console.error("Error fetching collection:", error);
          } finally {
            this.loading = false;
          }
        }
      } catch (error) {
        console.error("Error in fetchWorkspaceData function:", error);
      }
    },

    async fetchGMBCategories() {
      try {
        const gmbCategories = await fetch(
          "https://firebasestorage.googleapis.com/v0/b/around-dev-1.appspot.com/o/gmb-categories%2Fgmb-categories.json?alt=media&token=cccd1123-19ac-4d68-a46a-56da6a0e481d"
        );
        this.categories = await gmbCategories.json();
        this.categoriesId = this.categories.map((item) => item.name);
      } catch (error) {
        console.error("Error fetching GMB data:", error);
        this.$alert.show("Error fetching GMB data");
      }
    },

    async fetchLastUpdatedAndRefreshed() {
      const workspaceDoc = doc(
        db,
        `users/${this.currentUID}/fly_workspaces/${this.WID}`
      );
      const workspaceSnapshot = await getDoc(workspaceDoc);
      if (workspaceSnapshot.exists()) {
        this.gmb_bulk_last_updated =
          workspaceSnapshot.data().gmb_bulk_last_updated;
      }
    },
    formatFetchedPhoneNumber(phone) {
      // Remove any existing +91, leading zeros, or spaces
      const cleanNumber = phone?.replace(/^\+91|^91|^0+|\s+/g, "").trim();
      // Add +91 prefix if not empty
      return cleanNumber ? `+91${cleanNumber}` : "";
    },
  },
};
</script>
